import {
  SELECT_WELL,
  ADD_TREATMENT_WELL,
  DELETE_TREATMENT_WELL,
  UPDATE_TREATMENT_WELL,
  SET_OFFSET_WELLS,
  ADD_OFFSET_WELL,
  DELETE_OFFSET_WELL,
  UPDATE_OFFSET_WELL,
  SEARCH,
  CLEAR_FPZ,
  SET_CARTOFACT_WELLS,
  SET_DIRECTIONAL_SURVEYS,
  ADD_FPZ_RADIUS,
  DELETE_FPZ_RADIUS,
  UPDATE_FPZ_RADIUS,
  SET_LOADING,
  SET_BOUNDING_BOX,
  SET_FILTER,
  SET_MAP,
  SET_FPZ_CONTACTS,
  SET_REPORT_IMAGES,
  SET_CURRENT_FPZ_REPORT,
  LOGOUT,
  SET_SELECTED_TREATMENT_WELLS,
  SET_OPERATOR,
  SET_COMPANY_IDS,
  SET_COMPANIES,
} from '../actions/types';

import { addUniqueByKey } from '../common/functions';

const INITIAL_STATE = {
  status: 0,
  loading: false,
  directionalSurveys: [],
  cartofactWells: [],
  selectedTreatmentWells: [], // selected treatment wells, array of objects
  filter: null,
  operator: null,
  companyIds: null,
  companies: null,
  boundingBox: null,
  map: {
    center: { lat: 50.5, lng: -105.8 },
    zoom: 5,
    boundingBox: null,
  },
  contacts: {
    operators: [],
    offsetOperators: [],
    otherContacts: [],
  },
  reportImages: {},
  fpz_report_id: null,
  report_name: '',
  report_description: '',
};

const fpzReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_MAP:
      return {
        ...state,
        map: action.payload,
      };
    case SET_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    case SET_OPERATOR:
      return {
        ...state,
        operator: action.payload,
      };
    case SET_COMPANIES:
      // get array of ids from array of objects and set as filter
      const ids = action.payload.map(o => Number(o.id));
      console.log('ids', ids);
      return {
        ...state,
        companies: action.payload,
        companyIds: ids,
      };
    case SET_CARTOFACT_WELLS:
      // console.log('SET_CARTOFACT_WELLS', action.payload);
      return {
        ...state,
        cartofactWells: action.payload,
      };
    case SET_DIRECTIONAL_SURVEYS: {
      const { well, directionalSurveys = [] } = action.payload;
      // console.log('SET_DIRECTIONAL_SURVEYS', action.payload);
      const updatedWells = state.selectedTreatmentWells.map(w => {
        if (w.unique_identifier === well.unique_identifier) {

          return { ...w, directionalSurveys: directionalSurveys };
        }
        return w;
      });
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      };
    }
    case ADD_FPZ_RADIUS: {
      const well = action.payload;
      const updatedWells = state.selectedTreatmentWells.map(w => {
        if (w.unique_identifier === well.unique_identifier) {
          const updatedRadiuses = [
            ...w.fpzRadiuses,
            {
              radius: 500,
              color: '#66FFFF',
            },
          ];
          return { ...w, fpzRadiuses: updatedRadiuses };
        }
        return w;
      });
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      };
    }
    case DELETE_FPZ_RADIUS: {
      const { index, well } = action.payload;
      const updatedWells = state.selectedTreatmentWells.map(w => {
        if (w.unique_identifier === well.unique_identifier) {
          const updatedRadiuses = [...w.fpzRadiuses];
          updatedRadiuses.splice(index, 1);
          return { ...w, fpzRadiuses: updatedRadiuses };
        }
        return w;
      });
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      };
    }
    case UPDATE_FPZ_RADIUS: {
      const { index, fpzRadius, well } = action.payload;
      const updatedWells = state.selectedTreatmentWells.map(w => {
        if (w.unique_identifier === well.unique_identifier) {
          const updatedRadiuses = [...w.fpzRadiuses];
          updatedRadiuses[index] = fpzRadius;
          return { ...w, fpzRadiuses: updatedRadiuses };
        }
        return w;
      });
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      };
    }
    case SELECT_WELL:
      return {
        ...state,
        selectedSession: action.payload,
      };
    case ADD_TREATMENT_WELL: {
      // [ { ...cartofactWell object, fpzRadiuses:[ array of radiuses ] } }
      const treatmentWell = action.payload;
      treatmentWell.fpzRadiuses = [
        {
          radius: 500,
          color: '#66FFFF',
        }
      ];
      return {
        ...state,
        selectedTreatmentWells: addUniqueByKey(state.selectedTreatmentWells, action.payload, 'unique_identifier'),
      }
    }
    case DELETE_TREATMENT_WELL: {
      const well = action.payload;
      const updatedWells = state.selectedTreatmentWells.filter(
        (w) => w.unique_identifier !== well.unique_identifier
      );
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      }
    }
    case UPDATE_TREATMENT_WELL: {
      // [ { ...cartofactWell object, fpzRadiuses:[ array of radiuses ] } }
      const { well, key, value } = action.payload;
      const updatedWells = state.selectedTreatmentWells.map(w => {
        if (w.unique_identifier === well.unique_identifier) {
          return { ...w, [key]: value };
        }
        return w;
      });
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      }
    }
    case SET_OFFSET_WELLS: {
      const { well, offsetWells = [] } = action.payload;
      console.log('SET_OFFSET_WELLS', action.payload);
      const updatedWells = state.selectedTreatmentWells.map(w => {
        if (w.unique_identifier === well.unique_identifier) {
          const combined = [
            //...(Array.isArray(w.offsetWells) ? w.offsetWells : []), 
            ...offsetWells,
          ];
          // Deduplicate any potential dups by unique_identifier
          const updatedOffsetWells = combined.reduce((acc, curr) => {
            if (!acc.some(w => w.unique_identifier === curr.unique_identifier)) {
              acc.push(curr);
            }
            return acc;
          }, []);

          return { ...w, offsetWells: updatedOffsetWells };
        }
        return w;
      });
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      };
    }
    case ADD_OFFSET_WELL: {
      const { well, offsetWell } = action.payload;
      const updatedWells = state.selectedTreatmentWells.map(w => {
        if (w.unique_identifier === well.unique_identifier) {
          const updatedOffsetWells = [
            ...w.offsetWells,
            offsetWell,
          ];
          return { ...w, offsetWells: updatedOffsetWells };
        }
        return w;
      });
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      };
    }
    case DELETE_OFFSET_WELL: {
      const { well, offsetWell } = action.payload;
      const updatedWells = state.selectedTreatmentWells.map(w => {
        if (w.unique_identifier === well.unique_identifier) {
          const updatedOffsetWells = w.offsetWells.filter(
            ow => ow.unique_identifier !== offsetWell.unique_identifier
          );
          return { ...w, offsetWells: updatedOffsetWells };
        }
        return w;
      });
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      };
    }
    case UPDATE_OFFSET_WELL: {
      const { index, offsetWell, well } = action.payload;
      const updatedWells = state.selectedTreatmentWells.map(w => {
        if (w.unique_identifier === well.unique_identifier) {
          const updatedOffsetWells = [...w.offsetWells];
          updatedOffsetWells[index] = offsetWell;
          return { ...w, offsetWells: updatedOffsetWells };
        }
        return w;
      });
      return {
        ...state,
        selectedTreatmentWells: updatedWells,
      };
    }
    case SET_SELECTED_TREATMENT_WELLS: {
      const { wells } = action.payload;
      return {
        ...state,
        selectedTreatmentWells: wells,
      };
    }
    case SET_FPZ_CONTACTS: {

      return {
        ...state,
        contacts: action.payload,
      };
    }
    case SET_REPORT_IMAGES: {

      return {
        ...state,
        reportImages: action.payload,
      };
    }
    case SET_CURRENT_FPZ_REPORT: {

      return {
        ...INITIAL_STATE,
        ...action.payload,
      };
    }
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case CLEAR_FPZ:
      return {
        ...INITIAL_STATE,
      };
    case LOGOUT:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default fpzReducer;